/* EASE Pause PDP. Works only inside [data-ease-pp]; adding to cart stays with the theme's <form is="product-form">. */
(function () {
  'use strict';

  var COOKIE_BANNER_ID = 'shopify-pc__banner';

  function init(root) {
    if (root.hasAttribute('data-pp-ready')) return;
    root.setAttribute('data-pp-ready', '');

    var dataEl = root.querySelector('[data-pp-data]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);

    function all(selector) {
      return Array.prototype.slice.call(root.querySelectorAll(selector));
    }
    function one(selector) {
      return root.querySelector(selector);
    }
    function setText(selector, text) {
      all(selector).forEach(function (el) {
        el.textContent = text;
      });
    }

    /* ---------- variants ---------- */

    var variants = data.variants;
    var current =
      variants.filter(function (v) {
        return v.id === data.currentId;
      })[0] || variants[0];

    function find(pkg, color) {
      return variants.filter(function (v) {
        return v.pkg === pkg && v.color === color;
      })[0];
    }

    var dayFormat = new Intl.NumberFormat('de-DE', { style: 'currency', currency: data.currency || 'EUR' });

    /* ---------- one or two chains (automatic DUO discount) ---------- */

    var qty = 1;
    var qtyInput = one('[data-pp-qty]');
    var duoKeep = typeof data.duoKeep === 'number' ? data.duoKeep : 1;

    // Same shape as the shop's own price texts ("€199" or "199 €"), cents only when needed.
    function money(cents) {
      var num = (Math.round(cents) / 100).toFixed(2).replace('.', ',').replace(/,00$/, '');
      return current.price_text.trim().charAt(0) === '€' ? '€' + num : num + ' €';
    }
    // "€17,80" -> 1780, "€15" -> 1500
    function cents(text) {
      var digits = parseInt(String(text).replace(/[^\d]/g, ''), 10) || 0;
      return /,\d\d/.test(text) ? digits : digits * 100;
    }

    function variantName(v) {
      if (data.singlePkg) return data.colorLabels[v.color];
      return data.pkgLabels[v.pkg] + ' · ' + data.colorLabels[v.color];
    }

    function render() {
      var factor = qty === 2 ? 2 * duoKeep : 1;
      setText('[data-pp-price]', current.price_text);
      setText('[data-pp-uvp]', current.uvp || '');
      all('[data-pp-uvp-row]').forEach(function (el) {
        el.hidden = !current.uvp;
      });
      setText('[data-pp-spar]', current.save || '');
      all('[data-pp-spar-row]').forEach(function (el) {
        el.hidden = !current.save;
      });
      setText('[data-pp-total]', qty === 2 ? money(current.price * factor) : current.price_text);
      setText('[data-pp-rate]', qty === 2 ? money(cents(current.rate_text) * factor) : current.rate_text);
      setText('[data-pp-menge-preis="1"]', current.price_text);
      setText('[data-pp-menge-preis="2"]', money(current.price * 2 * duoKeep));
      all('[data-pp-menge-alt]').forEach(function (el) {
        el.lastChild.textContent = money(current.price * 2);
      });
      all('[data-pp-menge]').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.getAttribute('data-pp-menge') === String(qty)));
      });
      if (qtyInput) qtyInput.value = qty;
      // EN: same shape as the shop's own prices (money); DE keeps its long-standing "0,35 €"
      setText('[data-pp-day]', data.lang === 'en' ? money(current.price / 365) : dayFormat.format(current.price / 100 / 365));
      var dayRow = one('[data-pp-day-row]');
      // per-day price only next to the 365 days of Inner EASE; unmapped products have no package, so it stays
      if (dayRow) dayRow.hidden = data.mapped && current.pkg !== 'premium';

      one('[data-pp-variant-id]').value = current.id;
      all('[data-pp-cta]').forEach(function (button) {
        button.disabled = !current.available;
        var price = button.querySelector('[data-pp-cta-price]');
        if (price) price.hidden = !current.available;
        button.querySelector('[data-pp-cta-label]').textContent = current.available ? data.ctaLabel : data.soldOutLabel;
      });

      if (!data.mapped) return;

      setText('[data-pp-variant-name]', variantName(current));
      one('[data-pp-tier]').value = current.pkg;
      all('[data-pp-pkg-price]').forEach(function (el) {
        var v = find(el.getAttribute('data-pp-pkg-price'), current.color);
        el.textContent = v ? v.price_text : '';
      });
      all('[data-pp-pkg-uvp]').forEach(function (el) {
        var v = find(el.getAttribute('data-pp-pkg-uvp'), current.color);
        var uvp = v && v.uvp ? v.uvp : '';
        el.hidden = !uvp;
        if (el.lastChild && el.lastChild.nodeType === 3) el.lastChild.textContent = uvp;
        else if (uvp) el.appendChild(document.createTextNode(uvp));
      });      all('[data-pp-sw-price]').forEach(function (el) {
        var v = find(current.pkg, el.getAttribute('data-pp-sw-price'));
        el.textContent = v ? v.price_text : '';
      });
      var line = Object.keys(data.colorLabels)
        .map(function (color) {
          var v = find(current.pkg, color);
          return v ? data.colorLabels[color] + ' ' + v.price_text : '';
        })
        .filter(Boolean)
        .join(', ');
      setText('[data-pp-color-prices]', line + '.');
      setText(
        '[data-pp-color-label]',
        data.colorLabels[current.color] + (current.color === 'gold' ? ' · ' + data.goldNote : '')
      );
      all('[data-pp-cut]').forEach(function (img) {
        img.src = data.cutImages[current.color];
      });
      all('[data-pp-pkg]').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.getAttribute('data-pp-pkg') === current.pkg));
      });
      all('[data-pp-color]').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.getAttribute('data-pp-color') === current.color));
      });
    }

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-pp-menge]');
      if (!button || !root.contains(button)) return;
      qty = button.getAttribute('data-pp-menge') === '2' ? 2 : 1;
      render();
    });

    function choose(pkg, color) {
      // a colour may not exist in the current package (market catalogue): fall back to any package that has it
      var next =
        find(pkg, color) ||
        variants.filter(function (v) {
          return v.color === color && v.pkg;
        })[0];
      if (!next) return;
      current = next;
      render();
      var url = new URL(window.location.href);
      url.searchParams.set('variant', current.id);
      window.history.replaceState(window.history.state, '', url);
    }

    /* ---------- gallery ---------- */

    var slidesEl = one('[data-pp-slides]');
    var slides = all('[data-pp-slide]');
    var dots = one('[data-pp-dots]');
    var thumbs = one('[data-pp-thumbs]');
    var count = one('[data-pp-count]');
    var prev = one('[data-pp-prev]');
    var next = one('[data-pp-next]');

    function index() {
      var w = slidesEl.clientWidth;
      if (w <= 0) return 0;
      return Math.min(slides.length - 1, Math.round(slidesEl.scrollLeft / w));
    }

    function snapTo(k) {
      var w = slidesEl.clientWidth;
      if (w <= 0) return;
      var target = k * w;
      if (Math.abs(slidesEl.scrollLeft - target) > 0.5) {
        slidesEl.scrollLeft = target;
      }
    }

    // Changing --pp-ratio mid-swipe reflows height and desyncs scrollLeft (half-slide peek on iOS).
    // Only apply after the swipe settles, then re-snap.
    var ratioTimer = 0;
    var lastAppliedRatio = '';
    var onGalleryRatioChange = null;

    function applySlideRatio(k) {
      if (!data.galleryShopify) return;
      var shown = slides[k] && slides[k].querySelector('img');
      if (!shown) return;
      var stageEl = slidesEl.parentElement;
      var ratio = shown.getAttribute('width') + ' / ' + shown.getAttribute('height');
      var changed = ratio !== lastAppliedRatio;
      if (changed) {
        stageEl.style.setProperty('--pp-ratio', ratio);
        lastAppliedRatio = ratio;
      }
      // After layout (ratio or not), lock horizontal position to the active slide
      requestAnimationFrame(function () {
        snapTo(k);
        if (changed && typeof onGalleryRatioChange === 'function') onGalleryRatioChange();
      });
    }

    function mark() {
      var k = index();
      // off-screen slides are inert, so a link inside them cannot take focus and drag the gallery along
      slides.forEach(function (slide, j) {
        slide.inert = j !== k;
      });
      if (dots) {
        Array.prototype.forEach.call(dots.children, function (dot, j) {
          dot.classList.toggle('ease-pp-on', j === k);
        });
      }
      Array.prototype.forEach.call(thumbs.children, function (thumb, j) {
        thumb.setAttribute('aria-pressed', String(j === k));
      });
      var active = thumbs.children[k];
      if (active) thumbs.scrollLeft = active.offsetLeft - (thumbs.clientWidth - active.offsetWidth) / 2;
      count.textContent = k + 1 + ' / ' + slides.length;
      count.setAttribute('aria-label', data.imageLabel + ' ' + (k + 1) + ' ' + data.ofLabel + ' ' + slides.length);
      prev.disabled = k === 0;
      next.disabled = k === slides.length - 1;
    }

    function scheduleRatio() {
      if (!data.galleryShopify) return;
      clearTimeout(ratioTimer);
      ratioTimer = setTimeout(function () {
        applySlideRatio(index());
      }, 70);
    }

    function go(k) {
      k = Math.max(0, Math.min(slides.length - 1, k));
      clearTimeout(ratioTimer);
      if (data.galleryShopify) {
        // Ratio first so clientWidth matches the destination slide, then snap
        var shown = slides[k] && slides[k].querySelector('img');
        if (shown) {
          var ratio = shown.getAttribute('width') + ' / ' + shown.getAttribute('height');
          slidesEl.parentElement.style.setProperty('--pp-ratio', ratio);
          lastAppliedRatio = ratio;
        }
        requestAnimationFrame(function () {
          snapTo(k);
          mark();
          if (typeof onGalleryRatioChange === 'function') onGalleryRatioChange();
        });
        return;
      }
      snapTo(k);
      mark();
    }

    function goTo(key) {
      var k = slides
        .map(function (slide) {
          return slide.getAttribute('data-pp-slide');
        })
        .indexOf(key);
      if (k >= 0) go(k);
    }

    // picture 1 only exists in one colour: any other colour shows the three-colours photo instead.
    // An empty heroColor (gift box as picture 1) means picture 1 stands for no colour: it stays on load,
    // a colour click still shows the three-colours photo.
    function syncGalleryToColor() {
      if (data.galleryShopify) {
        if (current.slide) goTo(current.slide);
        return;
      }
      if (!data.mapped) return;
      if (current.color === data.heroColor) go(0);
      else goTo('farben');
    }

    slides.forEach(function (slide, j) {
      if (dots) dots.appendChild(document.createElement('i'));
      var button = document.createElement('button');
      var img = slide.querySelector('img');
      var caption = slide.querySelector('figcaption b, .ease-pp-zettel b');
      button.type = 'button';
      button.setAttribute('aria-label', data.imageLabel + ' ' + (j + 1) + (caption ? ': ' + caption.textContent : ''));
      if (slide.getAttribute('data-pp-slide') === 'preis') {
        button.textContent = '€';
      } else {
        var thumb = new Image();
        // lazy: the strip is hidden on mobile, so these never load there
        thumb.loading = 'lazy';
        thumb.decoding = 'async';
        thumb.src = img.currentSrc || img.src;
        thumb.alt = '';
        if (img.hasAttribute('data-pp-cut')) {
          thumb.className = 'ease-pp-contain';
          thumb.setAttribute('data-pp-cut', '');
        }
        button.appendChild(thumb);
      }
      button.addEventListener('click', function () {
        go(j);
      });
      thumbs.appendChild(button);
    });

    /* ---------- events ---------- */

    root.addEventListener('click', function (event) {
      var jump = event.target.closest('[data-pp-jump]');
      if (jump && root.contains(jump)) {
        event.preventDefault();
        var mobile = window.matchMedia('(max-width: 1023px)').matches;
        var sel = mobile
          ? jump.getAttribute('data-pp-jump-mobile')
          : jump.getAttribute('data-pp-jump-desktop');
        var target = sel && document.querySelector(sel);
        if (!target) return;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        return;
      }
      var button = event.target.closest('button');
      if (!button || !root.contains(button)) return;
      if (button.hasAttribute('data-pp-pkg')) {
        choose(button.getAttribute('data-pp-pkg'), current.color);
      } else if (button.hasAttribute('data-pp-color')) {
        choose(current.pkg, button.getAttribute('data-pp-color'));
        syncGalleryToColor();
      } else if (button === prev) {
        go(index() - 1);
      } else if (button === next) {
        go(index() + 1);
      }
    });

    slidesEl.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        go(index() + 1);
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        go(index() - 1);
      }
    });
    slidesEl.addEventListener(
      'scroll',
      function () {
        mark();
        scheduleRatio();
      },
      { passive: true }
    );
    slidesEl.addEventListener(
      'scrollend',
      function () {
        clearTimeout(ratioTimer);
        applySlideRatio(index());
      },
      { passive: true }
    );
    window.addEventListener('resize', function () {
      mark();
      applySlideRatio(index());
    });

    /* ---------- fixed buy bar ---------- */

    var sticky = one('[data-pp-sticky]');
    var mainCta = one('[data-pp-cta-main]');
    var inlineCtas = all('[data-pp-cta]').filter(function (button) {
      return !sticky.contains(button);
    });
    var visibleCtas = new Set();
    var end = one('[data-pp-end]');
    var ctaGone = false;
    var endReached = false;

    // Keep the bar hidden while either inline CTA is visible; exclude its own button.
    // Still wait until the main CTA has passed and hide at the section end to protect the footer.
    var barObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === mainCta) ctaGone = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        if (entry.target === end) {
          endReached = entry.isIntersecting || entry.boundingClientRect.top < 0;
        } else if (entry.isIntersecting) {
          visibleCtas.add(entry.target);
        } else {
          visibleCtas.delete(entry.target);
        }
      });
      sticky.classList.toggle('ease-pp-show', ctaGone && visibleCtas.size === 0 && !endReached);
    });
    inlineCtas.forEach(function (button) {
      barObserver.observe(button);
    });
    barObserver.observe(end);

    // Shopify injects its cookie banner late and fixed to the bottom edge. The bar stacks above it.
    var bannerSize = typeof ResizeObserver === 'function' ? new ResizeObserver(measureBanner) : null;
    var watchedBanner = null;

    function measureBanner() {
      var banner = document.getElementById(COOKIE_BANNER_ID);
      if (banner !== watchedBanner && bannerSize) {
        if (watchedBanner) bannerSize.unobserve(watchedBanner);
        if (banner) bannerSize.observe(banner);
        watchedBanner = banner;
      }
      var height = 0;
      if (banner) {
        var rect = banner.getBoundingClientRect();
        if (rect.height > 0) height = Math.max(0, window.innerHeight - rect.top);
      }
      root.style.setProperty('--ease-pp-cookie-h', height + 'px');
    }

    new MutationObserver(measureBanner).observe(document.body, { childList: true });
    window.addEventListener('resize', measureBanner);
    measureBanner();

    /* ---------- video in "Drei Handgriffe" ---------- */

    var video = one('[data-pp-video]');
    var play = one('[data-pp-play]');
    if (video && play) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        // no autoplay: the poster stays until the visitor asks for the film, then the native controls take over
        play.hidden = false;
        play.addEventListener('click', function () {
          play.hidden = true;
          video.controls = true;
          video.play();
        });
      } else {
        new IntersectionObserver(
          function (entries) {
            if (!entries[0].isIntersecting) video.pause();
            // play() rejects when the browser blocks autoplay (e.g. power saving): the poster simply stays
            else video.play().catch(function () {});
          },
          { threshold: 0.5 }
        ).observe(video);
      }
    }

    /* ---------- reels: silent loop while on screen, a tap turns the sound on ---------- */

    all('[data-pp-reel]').forEach(function (reel) {
      var ton = reel.parentNode.querySelector('[data-pp-reel-ton]');
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        new IntersectionObserver(
          function (entries) {
            if (!entries[0].isIntersecting) reel.pause();
            else reel.play().catch(function () {});
          },
          { threshold: 0.6 }
        ).observe(reel);
      }
      if (!ton) return;
      ton.addEventListener('click', function () {
        var on = reel.muted;
        // only one reel speaks at a time
        all('[data-pp-reel]').forEach(function (other) {
          other.muted = true;
          var b = other.parentNode.querySelector('[data-pp-reel-ton]');
          if (b) { b.setAttribute('aria-pressed', 'false'); b.textContent = data.soundOn; }
        });
        reel.muted = !on;
        if (on) reel.play().catch(function () {});
        ton.setAttribute('aria-pressed', on ? 'true' : 'false');
        ton.textContent = on ? data.soundOff : data.soundOn;
      });
    });

    /* ---------- ask button: opens the chat section on this page ---------- */

    var ask = one('[data-pp-ask]');
    if (ask && document.querySelector('[data-ease-ai-chat]')) {
      ask.hidden = false;
      ask.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('ease-ai:open'));
      });
    }

    /* ---------- mobile: gallery soft-parallax (transform-only, live rect, no hard snap) ---------- */

    var galcol = one('.ease-pp-galcol');
    var stage = one('.ease-pp-stage');
    var buycard = one('.ease-pp-buycard');
    var mobileScrollMq = window.matchMedia('(max-width: 1023px)');
    var reduceScrollMq = window.matchMedia('(prefers-reduced-motion: reduce)');
    var galleryScrollRaf = 0;
    var galleryRange = 240;
    var galleryMaxLag = 160;
    var galleryTargetScale = 0.92;
    var galleryEase = 0.14;
    var gLag = 0;
    var gOpacity = 1;
    var gScale = 1;
    var gLagTo = 0;
    var gOpacityTo = 1;
    var gScaleTo = 1;
    var gLastTop = null;
    var gIdleFrames = 0;

    function clearGalleryScrollStyles() {
      if (!stage) return;
      stage.classList.remove('ease-pp-stage--scroll');
      stage.style.transform = '';
      stage.style.opacity = '';
    }

    function hardResetGalleryScroll() {
      gLag = gLagTo = 0;
      gOpacity = gOpacityTo = 1;
      gScale = gScaleTo = 1;
      gLastTop = null;
      gIdleFrames = 0;
      clearGalleryScrollStyles();
    }

    function measureGalleryScroll() {
      if (!stage || !buycard || !galcol) return;
      hardResetGalleryScroll();
      var colH = galcol.offsetHeight || 400;
      galleryRange = Math.max(140, colH * 0.75);
      galleryMaxLag = colH * 0.45;
      var viewW = document.documentElement.clientWidth || window.innerWidth;
      var fullW = Math.max(1, viewW - 16);
      var buyW = buycard.offsetWidth || fullW;
      galleryTargetScale = Math.min(1, Math.max(0.84, buyW / fullW));
    }

    function readGalleryTargets() {
      // Live layout rect of galcol (child transforms do not affect it). Survives iOS chrome / momentum.
      var top = galcol.getBoundingClientRect().top;
      var scrolled = -top;
      if (scrolled < 0) scrolled = 0;
      var p = scrolled / galleryRange;
      if (p > 1) p = 1;

      if (p < 0.001) {
        gLagTo = 0;
        gOpacityTo = 1;
        gScaleTo = 1;
      } else {
        var lag = scrolled * 0.45;
        if (lag > galleryMaxLag) lag = galleryMaxLag;
        gLagTo = lag;
        gOpacityTo = 1 - p * 0.65;
        gScaleTo = 1 + (galleryTargetScale - 1) * p;
      }
      return top;
    }

    function tickGalleryScroll() {
      galleryScrollRaf = 0;
      if (!stage || !buycard || !galcol) return;
      if (!mobileScrollMq.matches || reduceScrollMq.matches) {
        hardResetGalleryScroll();
        return;
      }

      var top = readGalleryTargets();

      gLag += (gLagTo - gLag) * galleryEase;
      gOpacity += (gOpacityTo - gOpacity) * galleryEase;
      gScale += (gScaleTo - gScale) * galleryEase;

      // Soft snap only onto the target — never wipe mid-parallax styles (that caused the end jump)
      if (Math.abs(gLagTo - gLag) < 0.08) gLag = gLagTo;
      if (Math.abs(gOpacityTo - gOpacity) < 0.0015) gOpacity = gOpacityTo;
      if (Math.abs(gScaleTo - gScale) < 0.0004) gScale = gScaleTo;

      var atRest = gLagTo === 0 && gLag === 0 && gOpacity >= 0.999 && gScale >= 0.999;
      if (atRest) {
        clearGalleryScrollStyles();
        gLastTop = null;
        gIdleFrames = 0;
        return;
      }

      stage.classList.add('ease-pp-stage--scroll');
      stage.style.transform =
        'translate3d(0,' + gLag.toFixed(2) + 'px,0) scale(' + gScale.toFixed(4) + ')';
      stage.style.opacity = gOpacity.toFixed(3);

      var topChanged = gLastTop === null || Math.abs(top - gLastTop) > 0.05;
      gLastTop = top;
      var stillEasing =
        Math.abs(gLagTo - gLag) > 0.05 ||
        Math.abs(gOpacityTo - gOpacity) > 0.001 ||
        Math.abs(gScaleTo - gScale) > 0.0003;

      // Keep sampling through iOS momentum; stop only after a few idle settled frames
      if (topChanged || stillEasing) {
        gIdleFrames = 0;
        galleryScrollRaf = requestAnimationFrame(tickGalleryScroll);
      } else if (gIdleFrames < 8) {
        gIdleFrames += 1;
        galleryScrollRaf = requestAnimationFrame(tickGalleryScroll);
      }
    }

    function onGalleryScroll() {
      gIdleFrames = 0;
      if (galleryScrollRaf) return;
      galleryScrollRaf = requestAnimationFrame(tickGalleryScroll);
    }

    function onGalleryScrollMeasure() {
      measureGalleryScroll();
      onGalleryScroll();
    }

    if (stage && buycard && galcol) {
      // Remeasure parallax only when the stage ratio actually changes — not on every swipe frame
      onGalleryRatioChange = onGalleryScrollMeasure;
      window.addEventListener('scroll', onGalleryScroll, { passive: true });
      window.addEventListener('resize', onGalleryScrollMeasure, { passive: true });
      window.addEventListener('orientationchange', onGalleryScrollMeasure, { passive: true });
      if (typeof mobileScrollMq.addEventListener === 'function') {
        mobileScrollMq.addEventListener('change', onGalleryScrollMeasure);
        reduceScrollMq.addEventListener('change', onGalleryScrollMeasure);
      } else if (typeof mobileScrollMq.addListener === 'function') {
        mobileScrollMq.addListener(onGalleryScrollMeasure);
        reduceScrollMq.addListener(onGalleryScrollMeasure);
      }
      measureGalleryScroll();
      onGalleryScroll();
    }

    /* ---------- community photos: right-arrow scroll hint on mobile ---------- */

    var cgrid = one('[data-pp-cgrid]');
    var cnext = one('[data-pp-cnext]');
    var cindexCurrent = one('[data-pp-cindex-current]');
    if (cgrid) {
      var cCards = Array.prototype.slice.call(cgrid.querySelectorAll('.ease-pp-cbild'));
      function cIndex() {
        if (!cCards.length) return 0;
        var target = cgrid.getBoundingClientRect().left + 24;
        var best = 0;
        var bestDist = Infinity;
        cCards.forEach(function (card, i) {
          var dist = Math.abs(card.getBoundingClientRect().left - target);
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        });
        return best;
      }
      function updateCscroll() {
        var max = cgrid.scrollWidth - cgrid.clientWidth;
        var overflow = max > 12;
        var atEnd = cgrid.scrollLeft >= max - 8;
        if (cnext) cnext.hidden = !overflow || atEnd;
        if (cindexCurrent) cindexCurrent.textContent = String(cIndex() + 1);
      }
      if (cnext) {
        cnext.addEventListener('click', function () {
          var card = cCards[0];
          var step = card ? card.getBoundingClientRect().width * 0.85 : cgrid.clientWidth * 0.7;
          cgrid.scrollBy({ left: step, behavior: 'smooth' });
        });
      }
      cgrid.addEventListener('scroll', updateCscroll, { passive: true });
      window.addEventListener('resize', updateCscroll);
      if (typeof ResizeObserver === 'function') {
        new ResizeObserver(updateCscroll).observe(cgrid);
      }
      updateCscroll();
    }

    render();
    if (data.mapped && data.heroColor && current.color !== data.heroColor) goTo('farben');
    else {
      mark();
      applySlideRatio(index());
    }
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ease-pp]'), init);
  }

  initAll();
  // theme editor re-renders the section without a page load
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
